(function () {
  'use strict';

  /* Galerie de fiche produit : piste defilante a accrochage.
     Pourquoi pas vd-carrousel.js : celui du hero est un fondu croise, il
     bascule `est-actif` et `inert` sur des slides superposes et pilote un
     autoplay. Ici la mecanique est le defilement natif -- doigt, trackpad,
     molette horizontale, barre de defilement -- et le JS ne fait que
     synchroniser des reperes. Les fondre dans un composant commun demanderait
     deux chemins de code dans chaque fonction ; deux petits fichiers sont plus
     honnetes.

     Sans JavaScript, la piste defile quand meme et les trois visuels restent
     accessibles : tout ce qui suit est une amelioration, jamais la condition
     d'acces au contenu.

     Aucun defilement automatique, donc aucun bouton pause a prevoir
     (WCAG 2.2.2 ne s'applique pas a un mouvement declenche par l'utilisateur). */

  if (window.VD_GALERIE_INIT) return;
  window.VD_GALERIE_INIT = true;

  var REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SURVOL_FIN = window.matchMedia('(hover: hover) and (pointer: fine)');
  var instances = [];

  function creerGalerie(racine) {
    var piste = racine.querySelector('[data-vd-galerie-piste]');
    if (!piste) return null;
    var vues = Array.prototype.slice.call(piste.querySelectorAll('[data-vd-vue]'));
    if (vues.length < 2) {
      racine.classList.add('est-unique');
      return null;
    }

    var conteneurPuces = racine.querySelector('[data-vd-galerie-puces]');
    var compteur = racine.querySelector('[data-vd-galerie-compteur]');
    var precedent = racine.querySelector('[data-vd-galerie="precedent"]');
    var suivant = racine.querySelector('[data-vd-galerie="suivant"]');
    var modelePuce = conteneurPuces ? conteneurPuces.getAttribute('data-libelle-puce') || '' : '';
    var modeleCompteur = compteur ? compteur.getAttribute('data-libelle-compteur') || '' : '';
    var modeleVue = piste.getAttribute('data-libelle-vue') || '';
    var puces = [];
    var index = 0;
    var cible = null;
    var observateur = null;
    var trameSurvol = 0;

    /* `index` est la vue reellement a l'ecran, tenue par l'observateur ;
       `cible` la vue demandee tant que le defilement doux n'y est pas.
       Les reperes suivent la cible des le clic : le retour est immediat, et
       un second clic pendant le trajet part de la vue demandee au lieu de
       la redemander (deux clics a 120 ms n'avancaient que d'une vue,
       mesure du 2026-09-13). */
    function rangAnnonce() {
      return cible === null ? index : cible;
    }

    function annoncer() {
      var rang = rangAnnonce();
      for (var i = 0; i < puces.length; i++) {
        if (i === rang) {
          puces[i].setAttribute('aria-current', 'true');
        } else {
          puces[i].removeAttribute('aria-current');
        }
      }
      /* Le compteur visible EST la region vivante : un texte cache en double
         ferait annoncer deux fois la meme chose. */
      if (compteur) {
        compteur.textContent = modeleCompteur
          .replace('__RANG__', String(rang + 1))
          .replace('__TOTAL__', String(vues.length));
      }
      if (precedent) precedent.setAttribute('aria-disabled', String(rang === 0));
      if (suivant) suivant.setAttribute('aria-disabled', String(rang === vues.length - 1));
    }

    function allerA(rang) {
      rang = Math.max(0, Math.min(vues.length - 1, rang));
      cible = rang === index ? null : rang;
      annoncer();
      /* scrollTo plutot que scrollIntoView : celui-ci fait aussi defiler la
         PAGE pour amener la piste dans la vue, ce qui arrache la lecture. */
      piste.scrollTo({
        left: vues[rang].offsetLeft - vues[0].offsetLeft,
        behavior: REDUIT.matches ? 'auto' : 'smooth'
      });
    }

    /* L'index suit le defilement reel, d'ou qu'il vienne : clic, doigt,
       trackpad. Se fier aux seuls boutons ferait mentir les reperes des que
       quelqu'un glisse avec le doigt. */
    if (typeof window.IntersectionObserver === 'function') {
      observateur = new window.IntersectionObserver(
        function (entrees) {
          for (var i = 0; i < entrees.length; i++) {
            if (!entrees[i].isIntersecting) continue;
            var rang = vues.indexOf(entrees[i].target);
            if (rang !== -1 && rang !== index) {
              index = rang;
              if (cible === rang) cible = null;
              if (cible === null) annoncer();
            }
          }
        },
        { root: piste, threshold: 0.6 }
      );
      vues.forEach(function (vue) {
        observateur.observe(vue);
      });
    }

    /* « 2 sur 3 » pose ici et pas en Liquid : le total depend du nombre de vues
       reellement rendues, que deux boucles Liquid independantes (trio de
       parfum, puis images Shopify) ne sauraient pas compter a l'avance. */
    if (modeleVue) {
      vues.forEach(function (vue, rang) {
        vue.setAttribute('aria-label', modeleVue
          .replace('__RANG__', String(rang + 1))
          .replace('__TOTAL__', String(vues.length)));
      });
    }

    if (conteneurPuces) {
      vues.forEach(function (vue, rang) {
        var puce = document.createElement('button');
        puce.type = 'button';
        puce.className = 'galerie__puce';
        puce.setAttribute('aria-label', modelePuce
          .replace('__RANG__', String(rang + 1))
          .replace('__TOTAL__', String(vues.length)));
        var couleur = vue.getAttribute('data-couleur');
        if (couleur) puce.style.setProperty('--puce-teinte', couleur);
        var vignette = vue.getAttribute('data-vignette');
        if (vignette) puce.style.setProperty('--vignette', 'url("' + vignette + '")');
        puce.addEventListener('click', function () {
          allerA(rang);
        });
        conteneurPuces.appendChild(puce);
        puces.push(puce);
      });
    }

    function surPrecedent() {
      allerA(rangAnnonce() - 1);
    }

    function surSuivant() {
      allerA(rangAnnonce() + 1);
    }

    /* L'utilisateur reprend la main (molette, doigt, barre de defilement)
       ou le trajet s'acheve : la cible n'a plus de sens, les reperes
       reviennent a la vue observee. */
    var REPRISES = ['wheel', 'touchstart', 'pointerdown', 'scrollend'];

    function surReprise() {
      if (cible === null) return;
      cible = null;
      annoncer();
    }

    function surTouche(evt) {
      if (evt.key === 'ArrowLeft') {
        surPrecedent();
      } else if (evt.key === 'ArrowRight') {
        surSuivant();
      } else {
        return;
      }
      evt.preventDefault();
    }

    /* Le zoom suit le curseur : l'origine de la transformation est posee en
       variables CSS, le grossissement reste dans la feuille de style. Souris
       fine seulement, et jamais en mouvement reduit. */
    function surSurvol(evt) {
      if (trameSurvol) return;
      trameSurvol = window.requestAnimationFrame(function () {
        trameSurvol = 0;
        var vue = evt.target.closest ? evt.target.closest('[data-vd-vue]') : null;
        if (!vue) return;
        var boite = vue.getBoundingClientRect();
        vue.style.setProperty('--loupe-x', ((evt.clientX - boite.left) / boite.width * 100).toFixed(2) + '%');
        vue.style.setProperty('--loupe-y', ((evt.clientY - boite.top) / boite.height * 100).toFixed(2) + '%');
      });
    }

    if (precedent) precedent.addEventListener('click', surPrecedent);
    if (suivant) suivant.addEventListener('click', surSuivant);
    racine.addEventListener('keydown', surTouche);
    REPRISES.forEach(function (type) {
      piste.addEventListener(type, surReprise, { passive: true });
    });
    if (SURVOL_FIN.matches && !REDUIT.matches) {
      piste.addEventListener('mousemove', surSurvol);
      racine.classList.add('a-la-loupe');
    }

    racine.classList.add('est-initialise');
    annoncer();

    return {
      racine: racine,
      detruire: function () {
        if (observateur) observateur.disconnect();
        if (trameSurvol) window.cancelAnimationFrame(trameSurvol);
        if (precedent) precedent.removeEventListener('click', surPrecedent);
        if (suivant) suivant.removeEventListener('click', surSuivant);
        racine.removeEventListener('keydown', surTouche);
        REPRISES.forEach(function (type) {
          piste.removeEventListener(type, surReprise);
        });
        piste.removeEventListener('mousemove', surSurvol);
        puces.forEach(function (puce) {
          puce.remove();
        });
        racine.classList.remove('est-initialise', 'a-la-loupe');
        delete racine.dataset.vdGalerieActive;
      }
    };
  }

  function initDans(perimetre) {
    var racines = perimetre.querySelectorAll('[data-vd-galerie-racine]');
    Array.prototype.forEach.call(racines, function (racine) {
      if (racine.dataset.vdGalerieActive) return;
      racine.dataset.vdGalerieActive = 'true';
      var instance = creerGalerie(racine);
      if (instance) instances.push(instance);
    });
  }

  function detruireDans(perimetre) {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (perimetre.contains(instances[i].racine)) {
        instances[i].detruire();
        instances.splice(i, 1);
      }
    }
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initDans(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    detruireDans(evt.target);
  });

  initDans(document);
})();
